import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IDealerExceptionals } from '../models/models'

export class GetDealerExceptionalsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealerXml/getDealerExceptionals',
      requesterInfo,
    })
  }

  public async getDealerExceptionals(DealerCode: string): Promise<IDealerExceptionals> {
    this.props.url = `${this.props.url}?DealerCode=${DealerCode}`
    return await this.getAsync<IDealerExceptionals>()
  }
}
